/**
 * Modal Component - модальное окно
 */

import React from "react";

const Modal = ({
    isOpen,
    onClose,
    title,
    children,
    size = "md", // sm | md | lg | fullscreen
    showCloseButton = true,
    closeOnOverlayClick = true,
    className = "",
    ...props
}) => {
    const baseClass = "modal";
    const classes = [
        baseClass,
        `${baseClass}--${size}`,
        isOpen && `${baseClass}--open`,
        className,
    ]
        .filter(Boolean)
        .join(" ");

    const handleOverlayClick = (e) => {
        if (closeOnOverlayClick && e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className={classes} onClick={handleOverlayClick} {...props}>
            <div className={`${baseClass}__content`}>
                {showCloseButton && (
                    <button
                        className={`${baseClass}__close`}
                        onClick={onClose}
                        aria-label="Закрыть"
                    >
                        ×
                    </button>
                )}

                {title && <h2 className={`${baseClass}__title`}>{title}</h2>}

                <div className={`${baseClass}__body`}>{children}</div>
            </div>
        </div>
    );
};

export default Modal;
